import { Component, OnDestroy, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import {
  AiChatWindowService,
  AuthenticationService,
  ProjectService,
} from 'services/index';
import { Store } from '@ngrx/store';
import { eq } from 'lodash';
import { AppState } from 'app/app.reducer';
import * as actions from 'redux/actions';
import { Actions, ofType } from '@ngrx/effects';
import { distinctUntilKeyChanged } from 'rxjs/operators';
import { Search, Notification } from 'app/models';
import { Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { ExportFilenameService } from 'app/components';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public username: string;
  public projectLogo: string;
  public projectLogoAvailable = true;
  public name: string;
  public accountId: any;
  public showMenu: string;
  public showSubMenu: string;
  public headerHome: string;
  public headerNewsFeed: string;
  public headerAskAi: string;
  public headerExportExcel: string;
  public headerTopic: string;
  public headerContentItems: string;
  public headerAuthor: string;
  public headerOutlet: string;
  public headerReports: string;
  public reportsTotalItems: number;
  public showTopicContent: boolean;
  public showAuthorContent: boolean;
  public showOutletContent: boolean;
  public showContentItemContent: boolean;
  public showRankedList: boolean;
  public showCompaniesRankedList: boolean;
  public showSpinnerProjects: boolean;
  public sidebarnavItems: any[];
  public arrowIcon: string;
  public visibleSidebar: boolean;
  public newSearch: Search;
  public currentProject: any;
  public activeState: boolean[];
  public animationOptions: string;
  public cPanelSizes: number[];
  public topicTotalItems: number;
  public competitorTotalItems: number;
  public contentItemsTotalItems: number;
  public authorTotalItems: number;
  public outletTotalItems: number;
  public currentIndexTab: number;
  public prevIndexTab: number;
  public isExportingExcel: boolean;
  public headerMenuActive: string;
  public highlightedBadges: { [key: string]: boolean };
  private badgeHighlightTimers: { [key: string]: any };
  private badgeHighlightSubscription: Subscription;
  private projectLogoSubscription: Subscription;
  private readonly badgeHighlightDuration = 3000;
  private readonly reportsTabIndex = 5;
  private readonly newsFeedTabIndex = 6;
  private readonly askAiTabIndex = 7;

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private authenticationService: AuthenticationService,
    private projectService: ProjectService,
    private store: Store<AppState>,
    private router: Router,
    private actions$: Actions,
    private exportFilenameService: ExportFilenameService,
    private aiChatWindowService: AiChatWindowService
  ) {
    this.showMenu = '';
    this.showSubMenu = '';
    this.animationOptions = '800ms cubic-bezier(0.86, 0, 0.07, 1)';
    this.showTopicContent = false;
    this.showAuthorContent = false;
    this.showOutletContent = false;
    this.showContentItemContent = false;
    this.activeState = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
    this.cPanelSizes = [30, 70];
    this.contentItemsTotalItems = 0;
    this.topicTotalItems = 0;
    this.competitorTotalItems = 0;
    this.authorTotalItems = 0;
    this.outletTotalItems = 0;
    this.reportsTotalItems = 0;
    this.isExportingExcel = false;
    this.headerMenuActive = '';
    this.highlightedBadges = {};
    this.badgeHighlightTimers = {};
  }

  // End open close
  ngOnInit() {
    this.showSpinnerProjects = true;
    this.store
      .select('ui')
      .subscribe(({ visible, indexTab, headerMenuActive }) => {
        this.visibleSidebar = visible;
        this.headerMenuActive = headerMenuActive;
        this.arrowIcon = visible
          ? 'pi pi-angle-double-left'
          : 'pi pi-angle-double-right';
        this.headerNewsFeed = visible ? 'News Feed' : '';
        this.headerAskAi = visible ? 'Ask AI' : '';
        this.headerExportExcel = visible ? 'Export Data' : '';
        this.headerTopic = visible ? 'Topics' : '';
        this.headerContentItems = visible ? 'Articles' : '';
        this.headerAuthor = visible ? 'Authors' : '';
        this.headerOutlet = visible ? 'Outlets' : '';
        this.headerReports = visible ? 'Reports' : '';
        this.headerHome = visible ? 'Home' : '';
        this.currentIndexTab = indexTab || 0;
        if (!visible) {
          this.activeState = [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ];
        }
      });

    this.store
      .select('projects')
      .subscribe(({ action, loaded, loading, error }) => {
        this.showSpinnerProjects = loading;
        if (loaded) {
          this.showSpinnerProjects = false;
        }
        // if (error) {
        //   this.store.dispatch(
        //     actions.showNotification({
        //       notify: new Notification(`Error to load projects.`, 'error', 'tl')
        //     })
        //   );
        // }
      });

    this.store
      .select('project')
      .pipe(distinctUntilKeyChanged('projectSelected'))
      .subscribe(({ projectSelected }) => {
        if (projectSelected) {
          this.currentProject = projectSelected;
          // this.handleShowTopicSection({ index: 0 });
          this.showTopicContent = false;
          this.showAuthorContent = false;
          this.showOutletContent = false;
          this.showContentItemContent = false;
          this.projectLogoAvailable = true;
          this.projectLogo = this.projectService.getProjectLogo(
            this.currentProject.value,
            true
          );
          this.accordinToggle();
        }
      });

    // If a new logo gets uploaded for the project, update it here
    this.projectLogoSubscription =
      this.projectService.projectLogoUpdated$.subscribe((projectId) => {
        if (this.currentProject && this.currentProject.value === projectId) {
          this.projectLogoAvailable = true;
          this.projectLogo = this.projectService.getProjectLogo(
            projectId,
            true
          );
        }
      });

    this.store
      .select('authorsOutletsList')
      .pipe(distinctUntilKeyChanged('authors'))
      .subscribe(({ authors }) => {
        this.authorTotalItems = authors.filter(
          (author) => author?.label?.name !== 'Ignore'
        ).length;
      });

    this.store
      .select('authorsOutletsList')
      .pipe(distinctUntilKeyChanged('outlets'))
      .subscribe(({ outlets }) => {
        this.outletTotalItems = outlets.filter(
          (outlet) => outlet?.label?.name !== 'Ignore'
        ).length;
      });

    this.store
      .select('topics')
      .pipe(distinctUntilKeyChanged('topics'))
      .subscribe(({ topics }) => {
        this.competitorTotalItems = topics.filter((topic) =>
          eq(topic?.categoryName, 'Competitor')
        ).length;
        this.topicTotalItems = topics.filter(
          (topic) =>
            !eq(topic?.categoryName, 'Competitor') &&
            !eq(topic?.categoryName, 'Ignore')
        ).length;
      });

    combineLatest([
      this.store.select('contentItemsList'),
      this.store.select('authorsOutletsList'),
    ]).subscribe(([{ contentItems }, { outlets }]) => {
      this.contentItemsTotalItems = contentItems.filter((item) => {
        const outlet = outlets.find(
          (candidate) => candidate.partyId === item.outletId
        );
        return outlet?.label?.name !== 'Ignore';
      }).length;
    });

    this.store
      .select('myReportsList')
      .pipe(distinctUntilKeyChanged('reports'))
      .subscribe(({ reports }) => {
        this.reportsTotalItems = reports.length;
      });

    this.sidebarnavItems = ROUTES.filter((sidebarnavItem) => sidebarnavItem);
    this.subscribeToBadgeHighlightActions();
  }

  ngOnDestroy() {
    if (this.badgeHighlightSubscription) {
      this.badgeHighlightSubscription.unsubscribe();
    }
    if (this.projectLogoSubscription) {
      this.projectLogoSubscription.unsubscribe();
    }
    Object.keys(this.badgeHighlightTimers).forEach((key) => {
      clearTimeout(this.badgeHighlightTimers[key]);
    });
  }

  handleShowTopicSection({ index }) {
    if (eq(index, this.newsFeedTabIndex)) {
      this.showTopicContent = false;
      this.showAuthorContent = false;
      this.showOutletContent = false;
      this.showContentItemContent = false;
      this.store.dispatch(
        actions.showAppSections({
          showNewsFeedSection: true,
          showTopicSection: false,
          showCoverageSection: false,
          showCollectionSection: false,
        })
      );
      this.store.dispatch(actions.tabControl({ index: 0 }));
      this.store.dispatch(
        actions.headerMenuActive({
          menuActive: 'Topics',
        })
      );
    } else if (eq(index, this.reportsTabIndex)) {
      this.store.dispatch(actions.showSidebar());
      return;
    } else if (eq(index, this.askAiTabIndex)) {
      return;
    } else {
      this.store.dispatch(actions.showSidebar());
      if (this.headerMenuActive !== 'MyCoverage') {
        this.store.dispatch(
          actions.showAppSections({
            showNewsFeedSection: false,
            showTopicSection: true,
            showCoverageSection: false,
            showCollectionSection: false,
          })
        );
        this.store.dispatch(
          actions.headerMenuActive({
            menuActive: 'Home',
          })
        );
      }
    }
    this.prevIndexTab = this.currentIndexTab;
  }

  toggleChat() {
    this.aiChatWindowService.toggle();
  }

  accordinToggle() {
    this.activeState = [
      this.showAuthorContent,
      this.showOutletContent,
      this.showTopicContent,
      this.showContentItemContent,
      false,
      false,
      false,
      false,
      false,
    ];
  }

  logoutUrl() {
    return this.authenticationService.getLogoutUrl();
  }

  removePermission() {
    this.authenticationService.logOut();
  }

  handleSidebarOpen() {
    this.store.dispatch(actions.toggleShowSidebar());
  }

  openProjectSettings() {
    if (this.currentProject) {
      this.store.dispatch(
        actions.showSelectProjectModal({ projectId: this.currentProject.value })
      );
    }
  }

  openNewsFeed() {
    // this.prevIndexTab = this.currentIndexTab;
    // this.store.dispatch(actions.tabControl({ index: 0 }));
    this.showOutletContent = false;
    this.showTopicContent = false;
    this.showAuthorContent = false;
    this.showContentItemContent = false;
    this.store.dispatch(
      actions.showAppSections({
        showNewsFeedSection: true,
        showTopicSection: false,
        showCoverageSection: false,
        showCollectionSection: false,
      })
    );
  }

  promptExportFilename() {
    if (!this.currentProject || this.isExportingExcel) {
      return;
    }
    this.exportFilenameService
      .prompt(`TechNews_${this.currentProject.name}.xls`)
      .subscribe((filename) => {
        if (filename) {
          this.handleExportToExcel(filename);
        }
      });
  }

  handleExportToExcel(filename: string) {
    this.isExportingExcel = true;
    this.projectService
      .exportProjectToExcel(this.currentProject.value)
      .subscribe({
        next: (response: Blob) => {
          if (response && response.size > 0) {
            const blob = new Blob([response], {
              type: 'application/vnd.ms-excel',
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.isExportingExcel = false;
            }, 100);
          } else {
            this.isExportingExcel = false;
            this.store.dispatch(
              actions.showNotification({
                notify: new Notification(
                  'No data received from server',
                  'error',
                  'tr'
                ),
              })
            );
          }
        },
        error: (error) => {
          this.isExportingExcel = false;
          this.store.dispatch(
            actions.showNotification({
              notify: new Notification(
                'Error exporting to Excel',
                'error',
                'tr'
              ),
            })
          );
        },
      });
  }

  isAdmin() {
    return this.authenticationService.isAdminUser();
  }

  hasReportingAccess() {
    return this.authenticationService.hasReportingAccess();
  }

  isDev() {
    return this.authenticationService.isDevUser();
  }

  changeResizeSplitterPanel(e) {}

  private subscribeToBadgeHighlightActions() {
    this.badgeHighlightSubscription = new Subscription();

    this.badgeHighlightSubscription.add(
      this.actions$
        .pipe(ofType(actions.addMyReportSuccess))
        .subscribe(() => this.highlightBadge('reports'))
    );
    this.badgeHighlightSubscription.add(
      this.actions$
        .pipe(
          ofType(actions.addTopicToProjectSuccess, actions.createTopicSuccess)
        )
        .subscribe(() => this.highlightBadge('topics'))
    );
    this.badgeHighlightSubscription.add(
      this.actions$
        .pipe(ofType(actions.addAuthorToProjectSuccess))
        .subscribe(() => this.highlightBadge('authors'))
    );
    this.badgeHighlightSubscription.add(
      this.actions$
        .pipe(ofType(actions.addOutletToProjectSuccess))
        .subscribe(() => this.highlightBadge('outlets'))
    );
    this.badgeHighlightSubscription.add(
      this.actions$
        .pipe(ofType(actions.saveContentItemToProjectSuccess))
        .subscribe(() => this.highlightBadge('contentItems'))
    );
  }

  private highlightBadge(key: string) {
    this.highlightedBadges = {
      ...this.highlightedBadges,
      [key]: true,
    };

    if (this.badgeHighlightTimers[key]) {
      clearTimeout(this.badgeHighlightTimers[key]);
    }

    this.badgeHighlightTimers[key] = setTimeout(() => {
      this.highlightedBadges = {
        ...this.highlightedBadges,
        [key]: false,
      };
      delete this.badgeHighlightTimers[key];
    }, this.badgeHighlightDuration);
  }

  public onImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    image.onerror = null;
    this.projectLogoAvailable = false;
  }
}
